// extracted by mini-css-extract-plugin
module.exports = {"menu":"Menu_menu__LwNw1","menuItem":"Menu_menuItem__QNfeo","active":"Menu_active__qTFtR"};